<template>
  <Modal :value="value" :title="title" :mask-closable="false" @on-visible-change="onVisibleChange">
    <p class="reason-desc" v-if="desc">{{ desc }}</p>
    <div v-if="kindOptions && kindOptions.length" class="reason-kind">
      <div class="reason-label">{{ kindLabel }} <span class="reason-required">*</span></div>
      <Select v-model="kind" transfer style="width: 100%" :placeholder="kindPlaceholder">
        <Option v-for="item in kindOptions" :value="item.code" :key="item.code">{{ item.text }}</Option>
      </Select>
    </div>
    <div class="reason-label">{{ label }} <span class="reason-required">*</span></div>
    <Input type="textarea" v-model="reason" :autosize="{minRows: 4, maxRows: 6}" :maxlength="500"
      :placeholder="placeholder"></Input>
    <div slot="footer">
      <Button type="text" @click="close">取消</Button>
      <Button type="primary" :loading="loading" @click="ok">确认</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'RecruitReasonModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '填写理由'
    },
    label: {
      type: String,
      default: '理由'
    },
    desc: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请填写理由'
    },
    initReason: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    kindOptions: {
      type: Array,
      default: null
    },
    kindLabel: {
      type: String,
      default: '类型'
    },
    kindPlaceholder: {
      type: String,
      default: '请选择'
    },
    initKind: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      reason: '',
      kind: ''
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.reason = this.initReason || ''
        this.kind = this.initKind || ''
      }
    }
  },
  methods: {
    onVisibleChange (val) {
      if (!val) {
        this.close()
      }
    },
    close () {
      this.$emit('input', false)
    },
    ok () {
      if (this.kindOptions && this.kindOptions.length && !this.kind) {
        this.$Message.error('请选择' + this.kindLabel)
        return
      }
      let reason = (this.reason || '').trim()
      if (!reason) {
        this.$Message.error('请填写' + this.label)
        return
      }
      this.$emit('on-ok', reason, this.kind || '')
    }
  }
}
</script>
<style scoped>
.reason-desc { margin-bottom: 12px; font-size: 13px; color: #808695; }
.reason-kind { margin-bottom: 12px; }
.reason-label { margin-bottom: 6px; font-size: 13px; color: #303133; }
.reason-required { color: #ed3f14; }
</style>



// WEBPACK FOOTER //
// RecruitReasonModal.vue?02dcf299